import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      color: palette.text.primary,
      width: '300px'
    },
    header: {
      backgroundColor: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      padding: '10px',
      color: palette.text.primary
    },
    container: {
      height: 'inherit'
    },
    labelTag: {
      display: 'flex',
      flexDirection: 'column'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
